<template>
  <div class="row">
    <div class="col-md-12 p-t-20">
      <h5 class="h5">
        <i class="fe fe-activity"></i> Informal Sector Enrollment Data
      </h5>
    </div>

    <div class="col-md-12">
      <div class="card m-b-30">
        <div class="card-header">
          <div class="row">
            <button
              type="button"
              class="btn btn-outline-primary"
              @click="getChart('Basic Healthcare Provision Fund')"
            >
              Basic Healthcare Provision Fund
            </button>

            <button
              type="button"
              class="btn btn-outline-success ml-4"
              @click="getChart('State Equity Program')"
            >
              State Equity Program
            </button>

            <button
              type="button"
              class="btn btn-outline-dark ml-4"
              @click="getChart('Voluntary Contributor')"
            >
              Voluntary Contributor
            </button>
          </div>
        </div>

        <div class="card-body">
          <highcharts :options="chartOptions"></highcharts>
        </div>
      </div>
    </div>
    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        loader="dots"
        :can-cancel="true"
        :is-full-page="fullPage"
      ></loading>
    </div>
  </div>
</template>
  
  <script>
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  components: {
    Loading,
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      title: "",
      points: [10, 0, 8, 2, 6, 4, 5, 5],
      chartType: "",
      sector: "Basic Healthcare Provision Fund",
      seriesColor: "#6fcd98",
      colorInputIsSupported: null,
      chartOptions: {},
    };
  },
  mounted() {
    this.getDashboardLGA();
  },
  methods: {
    getChart(param) {
      this.isLoading = true;
      this.sector = param;
      this.getDashboardLGA();
      this.isLoading = false;
    },
    getDashboardLGA() {
      this.axios
        .post("/api/v1/auth/DashboardLgaDataPrincipal/2679", {
          sector: this.sector,
        })
        .then((response) => {
          const data = response.data;
          const lgaSeries = data[0].lga;
          const drilldownSeries = Array.isArray(data[0].wards) ? data[0].wards : [];

          this.chartOptions = {
            chart: {
              type: "column",
            },
            title: {
              text: `${this.sector} Enrollees Distributed By LGA`,
            },
            subtitle: {
              text: "Click the columns to view wards and communities.",
            },
            accessibility: {
              announceNewData: {
                enabled: true,
              },
            },
            xAxis: {
              type: "category",
            },
            yAxis: {
              title: {
                text: "NUMBERS OF VULNERABLE ENROLLED",
              },
            },
            legend: {
              enabled: false,
            },
            plotOptions: {
              series: {
                borderWidth: 0,
                dataLabels: {
                  enabled: true,
                },
              },
            },
            tooltip: {
              headerFormat:
                '<span style="font-size:11px">{series.name}</span><br>',
              pointFormat:
                '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b><br/>',
            },
            // The API links each level by id: LGA point -> ward series (id = LGA name),
            // ward point -> community series (id = "ward-<id>"). Keep those ids as-is;
            // ward names repeat across LGAs, so they can't be used as drilldown keys.
            series: [lgaSeries],
            drilldown: {
              series: drilldownSeries.map((item) => ({
                ...item,
                data: (item.data || []).map((point) =>
                  // Communities come as [name, count] and are the last level.
                  Array.isArray(point) ? { name: point[0], y: point[1] } : point
                ),
              })),
            },
          };
        });
    },
  },
};
</script>
  
  <style>
</style>
  